import { UsersGetterTypes } from './types';

export const getters = {
    [UsersGetterTypes.GetUsers](state) {
        return (state.users && state.users.data) || []
    },
    [UsersGetterTypes.GetResponse](state) {
        return state.users
    }
}